import { Radio } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import CreateProfileCardWrapper from "../../components/common/CreateProfileCardWrapper";
import "./OnboardingPage.css";

const LiveInCanadaPage = ({ formik, IS_REVIEW }) => {
  const { t } = useTranslation();
  return (
    <>
      <CreateProfileCardWrapper>
        <h5 className="d-flex align-items-center justify-content-between">
          {t("aboutYou.ques3.title")}
        </h5>
        <Radio.Group
          className="w-100"
          name="livingInCanada"
          value={formik.values.livingInCanada}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        >
          <ul className="list-inline mb-0">
            <li>
              <Radio value="yes">{t("aboutYou.ques3.options.1")}</Radio>
            </li>
            <li>
              <Radio value="no" disabled={IS_REVIEW}>
                {t("aboutYou.ques3.options.2")}
              </Radio>
            </li>
            <li>
              <Radio value="justCurious" disabled={IS_REVIEW}>
                {t("aboutYou.ques3.options.3")}
              </Radio>
            </li>
          </ul>
        </Radio.Group>
        {formik.touched.livingInCanada && formik.errors.livingInCanada ? (
          <div className="error-message">{formik.errors.livingInCanada}</div>
        ) : null}
      </CreateProfileCardWrapper>
    </>
  );
};

export default LiveInCanadaPage;
